export default function base64URLEncode (str) {
  return str.toString('base64')
          .replace(/\+/g, '-')
          .replace(/\//g, '_')
          .replace(/=/g, '');
}



// WEBPACK FOOTER //
// ./src/base64URLEncode.js